import styled from 'styled-components';
import { SkeletonBody } from '../Skeleton/styles';

export const Wrapper = styled.article`
  position: relative;
  
  display: flex;
  flex-direction: column;

`;

export const Row = styled.div`
  height: ${({ height }) => `${height}px`};
  width: 100%;
  margin-bottom: 10px;

  ${SkeletonBody} {
    width: 100%;
    height: 100%;
  }
`;

